<!-- Translated: skip -->
<template>
  <Modal @close="cancel" :wide="false" width="500px">
    <h2>Behöver du mer än {{params.addon.plural[0] || 'en'}} {{params.addon.plural[1] || params.addon.arttext}}?</h2>

    <p>{{params.addon.plural[0] || 'En'}} <span class="lowercase">{{params.addon.plural[2] || params.addon.arttext}}</span> finns alltid i boendet, här lägger du till ytterligare en eller flera <span class="lowercase">{{params.addon.plural[3] || params.addon.arttext}}</span>.</p>

    <!-- <p>Vill du lägga till {{params.addon.qtySelected}} st <span class="lowercase">{{params.addon.arttext}}</span>?</p> -->

    <p>&nbsp;</p>

    <button class="small" @click="click">Ja, lägg till</button>
    <button class="small white border" @click="cancel">Nej, det räcker med {{params.addon.plural[0] || 'en'}}</button>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Login from '@/components/payments/Login';

import languageDetector from '@/mixins/languageDetector';

export default {
  props: {
    params: {},
  },
  mixins: [languageDetector],
  components: {
    Modal,
    Login,
  },
  data() {
    return {
      ssn: '',
      loading: false,
      error: false,
      appendedCount: 0,
    };
  },
  mounted() {
    this.ssn = (this.$store.state.cart.ssn || '');
  },
  computed: {
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    cancel() {
      this.closeModal();
    },
    click() {
      this.params.click();
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

h2
  font-size: 20px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  uppercase()

.modalo
  text-align center

.lowercase
  text-transform lowercase
</style>



// WEBPACK FOOTER //
// IncludedInPriceModal.vue?04168134